import { Directive } from '@angular/core';
import { AbstractControl, Validator, NG_VALIDATORS, ValidatorFn, UntypedFormControl } from '@angular/forms';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[typeCodeMatNumberValidator]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useClass: TypeCodeMatNumberValidatorDirective,
            multi: true
        }
    ],
    standalone: false
})
export class TypeCodeMatNumberValidatorDirective implements Validator {

  validator: ValidatorFn;
  constructor() {
    this.validator = this.typeCodeMatNumberValidator();
  }

  validate(c: UntypedFormControl) {
    return this.validator(c);
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // Helper validation, is used for...
  // => Keep previous error at keypress 
  //    This is needed to prevents the temporary disappearance of the validation error message during input at keypress event
  // => The main validation is done in the component generator.component.ts / generator-overview.component.ts in function initAutoComplete()
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  typeCodeMatNumberValidator(): ValidatorFn {
    return (control: AbstractControl) => {
       if (control.value !== null && control.value !== undefined && control.value !== '' && control.errors !== null && control.errors !== undefined) {
         return control.errors;
       } else {
         return null;
       }
    };
  } 
}
